import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { IconDefinition, faHeart as cuorevuoto } from '@fortawesome/free-regular-svg-icons';
import { faHeart as cuorepieno } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Space, Spin, Typography, message, theme } from 'antd';

import Configurazione from '../../Configurazione';
import { GetErrorMessage } from '../../Utility';
import stringres from '../../translations/stringres';
import '../Magazzino.css';
import { InfoBloccoModel } from '../Models/InfoBloccoModel';
import { PreferitiModel } from '../Models/PreferitiModel';
import Img from './../Img';
import { GestionePreferiti } from './GestionePreferiti';

export default function BloccoCardMagProp(item: InfoBloccoModel) {
    const { token } = theme.useToken();

    const [isRunning, setIsRunning] = useState(false);
    const [img, setImg] = useState('');
    const [iconaPreferiti, setIconaPreferiti] = useState<IconDefinition>(cuorevuoto);

    useEffect(() => {
        GetImg();
    }, [item]);

    const indirizzo = item.isCliente ? '/MagazzinoClientiDettaglio' : '/MagazzinoDettaglio';

    async function GetImg() {
        try {
            setIsRunning(true);

            const p = GestionePreferiti.getByStockGroupByBloccoModel(item.stock);
            p ? setIconaPreferiti(cuorepieno) : setIconaPreferiti(cuorevuoto);

            if (item.stock.nomeFile === null) {
                setImg('');
                return;
            }

            const res = await fetch(
                Configurazione().apiBaseUrl + 'Magazzino/GetFoto?fotoNome=' + item.stock.nomeFile + '&tipo=3'
            );

            if (res.status === 200) {
                const imageBlob = await res.blob();
                const imageObjectURL = URL.createObjectURL(imageBlob);

                if (imageObjectURL) setImg(imageObjectURL);
                else setImg('');
            } else setImg('');
        } catch (error) {
            message.error(GetErrorMessage(error));
        } finally {
            setIsRunning(false);
        }
    }

    function onclickpreferito() {
        const pref = GestionePreferiti.getByStockGroupByBloccoModel(item.stock);

        if (pref === null) {
            const p: PreferitiModel = {
                id: GestionePreferiti.getIdByStockGroupByBloccoModel(item.stock),
                numeroBlocco: item.stock.numeroBlocco,
                numeroBloccoFornitore: item.stock.numeroBloccoFornitore,
                monolama: item.stock.monolama,
                idQualita: item.stock.idQualita,
                qualita: item.stock.qualita,
                codFinitura: item.stock.codFinitura,
                finitura: item.stock.finitura,
                pezzi: item.stock.pezzi,
                qta: item.stock.qtaVen,
                um: item.stock.um,
                spessore: item.stock.spessore,
                nomeFile: item.stock.nomeFile,
            };
            GestionePreferiti.aggiungi(p);

            setIconaPreferiti(cuorepieno);

            message.success(stringres.t('preferitoAggiunto').toString());
        } else {
            GestionePreferiti.elimina(pref.id);

            setIconaPreferiti(cuorevuoto);

            message.success(stringres.t('preferitoEliminato').toString());
        }
    }

    return (
        <div style={{ margin: '10px' }}>
            <Spin spinning={isRunning}>
                <div style={{ position: 'relative' }}>
                    <Link
                        to={{ pathname: indirizzo }}
                        state={{
                            numeroBlocco: item.stock.numeroBlocco,
                            numeroBloccoFornitore: item.stock.numeroBloccoFornitore,
                            monolama: item.stock.monolama,
                            um: item.stock.um,
                            idQualita: item.stock.idQualita,
                            codFinitura: item.stock.codFinitura,
                            spessore: item.stock.spessore,
                        }}
                    >
                        <Img className="imagegallery" src={img} alt="" um={item.stock.um}></Img>
                    </Link>
                    <FontAwesomeIcon
                        style={{ position: 'absolute', top: '10px', right: '10%', cursor: 'pointer' }}
                        size="3x"
                        width={30}
                        icon={iconaPreferiti}
                        onClick={(event) => {
                            event.stopPropagation();
                            onclickpreferito();
                        }}
                    />
                </div>
                <div>
                    <Space direction="horizontal">
                        <Typography.Text>
                            <span style={{ color: token.colorPrimary }}>{item.stock.qualita}</span> -{' '}
                            {stringres.t('numeroBloccoshort').toString()} {item.stock.numeroBlocco} -{' '}
                            {stringres.t('numeroBloccoFornitoreshort').toString()}
                            {item.stock.numeroBloccoFornitore} {item.stock.monolama} - {item.stock.pezzi}{' '}
                            {stringres.t('pezzishort').toString()} - {item.stock.spessore}
                            {'cm'}
                        </Typography.Text>
                    </Space>
                </div>
            </Spin>
        </div>
    );
}
